import React from "react";
import ModuleContext from "../ModuleContext";

export interface ModuleContextProps {
  action?: Function;
  history?: History;
  loading?: boolean;
  location?: Location;
  match?: { path: string; url: string; isExact: boolean; params: {} };
  onSubmit?: Function;
  staticContext?: any;
  width?: number;
  metaData?: Object;
}

export default (Com: Function) => (props: ModuleContextProps) => {
  if (props.match) {
    const {
      match: { path }
    } = props;

    // If we don't pass the module, which is also part of the URL,
    // then we need to split the URL and extract the current module from there.
    // If we don't do that, every reload, or direct attempt to access the page
    // will be rejected and "null" would be shown.
    const extractedPath = path.split("/");
    const moduleFallback = extractedPath[1];

    return (
      <ModuleContext.Consumer>
        {module =>
          !module ? (
            // If we don't pass the module through steps...
            <Com module={moduleFallback} {...props} />
          ) : (
            // If we pass the module...
            <Com module={module} {...props} />
          )
        }
      </ModuleContext.Consumer>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/HOCs/getModuleContext.tsx